<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="650px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <div class="passwordBox">
        <div class="passwordBoxMsg">
          <!-- <i class="el-icon-warning warningMsg"></i> -->
          ●系统检查到您的密码过于简单，存在安全隐患，请立即修改登录密码。<br />
          ●密码规则:8-20个字符:密码为大写字母、小写字母、数字、特殊字符的组合，密码必须包含其中三种类型字符。
        </div>
        <div class="ruleFormCss">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
          >
            <el-form-item label="旧密码" prop="oldPassword">
              <el-input
                type="password"
                v-model="ruleForm.oldPassword"
                placeholder="请输入旧密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                type="password"
                v-model="ruleForm.newPassword"
                placeholder="请输入新密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input
                type="password"
                v-model="ruleForm.confirmPassword"
                placeholder="请输入确认密码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button
          type="primary"
          v-preventReClick
          @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/assets/js/api'
import login from '@/assets/js/login'
import { Encrypt } from '@/assets/js/utils'
export default {
  data () {
    var confirmPasswordFn = (rule, value, callback) => {
      if (this.ruleForm.newPassword === value) {
        callback()
      } else {
        callback(new Error('两次输入密码不一致!'))
      }
    }
    var newPasswordFn = (rule, value, callback) => {
      if (this.ruleForm.oldPassword === value) {
        callback(new Error('新密码不能等于旧密码!'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      currentUser: api.currentUser(),
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: newPasswordFn, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: confirmPasswordFn, trigger: 'blur' }
        ]
      },
      passWordRange: '',
      passWordContain_: '',
      pwdInfo: {}, // 用户设置的密码配置
      message: ''

    }
  },
  methods: {
    openChangePassword () {
      this.dialogVisible = true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const oldPas = Encrypt(this.ruleForm.oldPassword, sessionStorage.getItem('aesKey'))
          const newPas = Encrypt(this.ruleForm.newPassword, sessionStorage.getItem('aesKey'))
          // const oldPas = this.ruleForm.oldPassword
          // const newPas = this.ruleForm.newPassword
          this.verificationUserSetting(oldPas, newPas)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    verificationUserSetting (oldPas, newPas) {
      api.user.chgPassword(oldPas, newPas).then((res) => {
        if (res.data.code === '0') {
          this.$message.success(res.data.message)
          this.ruleForm = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
          }
          this.dialogVisible = false
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    resetForm (formName) {
      this.dialogVisible = false
      const _this = this
      this.$nextTick(function () {
        _this.$refs[formName].resetFields()
        login.logout().then((res) => {
          sessionStorage.clear()
          localStorage.clear()
          _this.$router.push('/login')
        })
      })
    },
    handleClose (done) {
      done()
    }
  },
  created () { }
}
</script>

<style scoped>
.passwordBox {
  text-align: center;
  width: 600px;
  margin: 0 auto;
}
.ruleFormCss {
  width: 520px;
  margin: 0 auto;
}
.passwordBoxMsg {
  margin-bottom: 20px;
  text-align: left;
}
.warningMsg {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/user/admin/changePassword/forcePasswordChange.vue